import type { Student } from '../api/students';

export type WaitTimePriority = 'normal' | 'moderate' | 'urgent';

export interface WaitTimeInfo {
  minutes: number;
  priority: WaitTimePriority;
  color: string;
  backgroundColor: string;
}

export const getWaitTimeInfo = (student: Student): WaitTimeInfo => {
  const now = new Date();
  const checkedInTime = new Date(student.checked_in_at);
  const waitMinutes = Math.floor((now.getTime() - checkedInTime.getTime()) / 60000);

  let priority: WaitTimePriority = 'normal';
  let color = '#2E7D32'; // green
  let backgroundColor = '#E8F5E9'; // light green

  if (waitMinutes >= 20) {
    priority = 'urgent';
    color = '#C62828'; // red
    backgroundColor = '#FFEBEE'; // light red
  } else if (waitMinutes >= 10) {
    priority = 'moderate';
    color = '#F57C00'; // orange
    backgroundColor = '#FFF3E0'; // light orange
  }

  return {
    minutes: waitMinutes,
    priority,
    color,
    backgroundColor,
  };
};

export const formatWaitTime = (minutes: number): string => {
  if (minutes < 1) return '< 1 min';
  if (minutes === 1) return '1 min';
  return `${minutes} mins`;
};

export const calculateAverageWaitTime = (students: Student[]): number => {
  const waitingStudents = students.filter(s => !s.dismissed_at);
  if (waitingStudents.length === 0) return 0;

  const now = new Date();
  const totalMinutes = waitingStudents.reduce((sum, student) => {
    const checkedInTime = new Date(student.checked_in_at);
    const waitMinutes = Math.floor((now.getTime() - checkedInTime.getTime()) / 60000);
    return sum + waitMinutes;
  }, 0);

  return Math.floor(totalMinutes / waitingStudents.length);
};
